// Ui
import { UiCommandEvent } from '@ui/cer-ui-types';

// Form
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormPanesSettingsUtil, CerFormPaneType } from '@form/cer-form-panes/cer-form-panes.service';
import { CerFormView } from '@form/cer-form-view';

// App
import { CustInvoiceService } from '../cust-invoice.service';
import { CustInvoiceView } from '../cust-invoice.view';

export class CustInvoiceForm extends CerFormAdapter {

  private routeParams: string[];
  private isDraft: boolean;
  private isCredit: boolean;

  private svc: CustInvoiceService;
  public override viewSetInit(viewSet: CerFormViewSet) {

    this.svc = this.routeOptions.context.injector.get(CustInvoiceService);

    this.routeParams = this.routeOptions.routeParams;
    this.isDraft = this.routeParams.filter(p => p == '$status=Draft').length > 0;
    this.isCredit = this.routeParams.filter(p => p == '$payment=Credit').length > 0;
   
    const headerView = this.headerViewGet('main');
    const lineView = this.lineViewGet('bottom')

    viewSet.panes = CerFormPanesSettingsUtil.masterDetail('vertical',true);
    viewSet.viewAdd(headerView);
    viewSet.viewAdd(lineView,headerView);
    
  }

  private headerViewGet(pane : CerFormPaneType): CerFormView {
    const view = new CerFormView();
    view.onCommandEvent = (e => this.onCommand(e));

    view.mandatory = true;
    view.paneTarget = pane;
    view.viewMetadata = CustInvoiceView.tableView(this.routeParams, this.isDraft);
    view.toolbarCommands = CustInvoiceView.tableToolbar(this.isDraft, this.isCredit);
    view.fieldMetadata = CustInvoiceView.tableFields(this.isDraft, false);
    return view;
  }

  private lineViewGet(pane : CerFormPaneType): CerFormView {
    const view = new CerFormView();
    view.onCommandEvent = (e => this.onCommand(e));

    view.mandatory = true;
    view.paneTarget = pane;
    view.viewMetadata = CustInvoiceView.lineView(this.isDraft);
    view.fieldMetadata = CustInvoiceView.lineFields(this.isDraft);
    view.toolbarCommands = CustInvoiceView.lineToolbar(this.isDraft);
    return view;
  }

  public onCommand(event: UiCommandEvent) {
    this.svc.onCommand(event);
  }
}
